export default __webpack_public_path__ + "static/media/pictogramCashFlow40.d7623579.svg";